import React, { useRef } from 'react';
import { TableContainer, Spinner, Kbd, Button } from '@chakra-ui/react';

import { Table, Thead, Tbody, Td, Th, Tr, Creatable } from 'common/materials';
import { UserCompany } from 'models/user/UserCompany';
import { useVirtualTableScrollbar } from 'common/hooks';
import { VirtualTableScrollbar } from 'common/components';

export type UserCompanyTableProps = {
    userCompanies: UserCompany[];
    isFetching?: boolean;
    className?: string;
    onEditCredential?: (user: UserCompany) => void;
};

export const UserCompanyTable = (props: UserCompanyTableProps) => {
    const { isFetching, userCompanies, className, onEditCredential } = props;

    const { tableContainerRef, virtualTableContainerRef, virtualTableRef, tableRefCallback } =
        useVirtualTableScrollbar();

    return (
        <div>
            <p className="text-right text-sm text-primary-900">
                Tips: สามารถกดปุ่ม <Kbd className="text-neutral-950">Shift</Kbd>{' '}
                ค้างและหมุนลูกกลิ้งเมาส์เพื่อเลื่อนตารางในแนวนอนได้
            </p>

            <VirtualTableScrollbar
                virtualTableContainerRef={virtualTableContainerRef}
                virtualTableRef={virtualTableRef}
            />
            <TableContainer
                ref={tableContainerRef}
                className="mt-1"
            >
                <Table ref={tableRefCallback}>
                    <Thead>
                        <Tr>
                            <Th></Th>
                            <Th>No</Th>
                            <Th className="sticky left-0 z-10 bg-gray-200">User</Th>
                            <Th>First Name</Th>
                            <Th>Last Name</Th>
                            <Th>Email</Th>
                            <Th>F1 Employee Code</Th>
                            <Th>F1 First Name</Th>
                            <Th>F1 Last Name</Th>
                            <Th>F1 First Name TH</Th>
                            <Th>F1 Last Name TH</Th>
                            <Th>F1 Email</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {userCompanies.length === 0 && (
                            <Tr>
                                <Td
                                    colSpan={13}
                                    className="text-center"
                                >
                                    {isFetching ? (
                                        <div className="flex items-center justify-center gap-2">
                                            <Spinner
                                                size="sm"
                                                className="text-primary-900"
                                            />
                                            <span className="text-sm text-primary-900">
                                                กำลังโหลดข้อมูล
                                            </span>
                                        </div>
                                    ) : (
                                        'No data'
                                    )}
                                </Td>
                            </Tr>
                        )}

                        {userCompanies.map((user, index) => (
                            <Tr key={user.citizen_id + user.sid + user.system_type}>
                                <Td className="space-x-1">
                                    <Button
                                        size="xs"
                                        variant="outline"
                                        colorScheme="primary"
                                        onClick={() => onEditCredential?.(user)}
                                    >
                                        แก้ไข
                                    </Button>
                                </Td>
                                <Td>{index + 1}</Td>
                                <Td className="sticky left-0 z-10 bg-white">{user.citizen_id}</Td>
                                <Td>{user.first_name}</Td>
                                <Td>{user.last_name}</Td>
                                <Td>{user.email}</Td>
                                <Td>{user.f1_employee_code}</Td>
                                <Td>{user.f1_first_name}</Td>
                                <Td>
                                    <span>{user.f1_last_name}</span>
                                </Td>
                                <Td>{user.f1_first_name_th}</Td>
                                <Td>
                                    <span>{user.f1_last_name_th}</span>
                                </Td>
                                <Td>{user.f1_email}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </div>
    );
};
